import tictactoeimage from '../assets/tictactoeimage.jpeg'
import currencyconverter from '../assets/currencyconverter.jpg'
import todolist from '../assets/todolist.jpg'
import thermomug from '../assets/thermomug.jpg'
import movieappimg from '../assets/movieappimg.jpg'
import enrollimg from '../assets/selenium-icon-19.jpg'
export const ProjectList=[

    {
        name:"TicTacToeGame",
        image : tictactoeimage,
        text: "Made using Java",
        repo:'https://github.com/OmarAbdelghanyyy/TicTacToeGame'
        
    },

    {
        name: "Real Time Currency Converter",
        image: currencyconverter,
        text : "Made using Java",
        repo: "https://github.com/OmarAbdelghanyyy/Currency-Converter"
    },
   
   
    {   
        name: "EnrolAutomation",
        image:enrollimg,
        text: "Made using Python",
        repo: "https://github.com/OmarAbdelghanyyy/EnrolAutomation"

    },

    {
        name:'ToDoList',
        image:todolist,
        text: "Made using React",
        repo:"https://github.com/OmarAbdelghanyyy/todolist"
    },

    {
        name: 'ThermoMug',
        image: thermomug,
        text: "Made using HTML, CSS and JavaScript",
        repo:"https://github.com/SEG2900-Group21/SEG2900-group21"
    },

    {
        name: "MovieApp",
        image: movieappimg,
        text: "Made using React",
        repo:"https://github.com/OmarAbdelghanyyy/MovieApp"
    }
]